<template>
  <!-- eslint-disable -->
  <div>
    <b-row class="mb-2">
      <b-col sm="12">
        <b-button variant="danger" @click="$router.go(-1)">Atras</b-button>
      </b-col>
    </b-row>
    <b-row v-if="datosMov">
      <b-col sm="12">
        <b-card no-body header-bg-variant="dark">
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información de Movimiento</h4>
          </b-card-header>
          <b-card-body class="mt-2">
            <b-row>
              <b-col sm="6" lg="3" class="flex">
                <strong>Tienda Destino: </strong>
                <p class="">{{ datosMov.establishmentDestiny.name }}</p>
              </b-col>
              <b-col sm="6" lg="3" class="flex">
                <strong>Tienda Origen: </strong>
                <p class="">{{ datosMov.establishmentOrigin.name }}</p>
              </b-col>
              <b-col sm="6" lg="2" class="flex">
                <strong>Número de documento: </strong>
                <p class="">{{ datosMov.documentCode }}</p>
              </b-col>
              <b-col sm="6" lg="2" class="flex">
                <strong v-if="datosMov.state === 'Despachado'"
                  >Despachado por:
                </strong>
                <strong
                  v-else-if="
                    datosMov.state === 'Anulado' ||
                    datosMov.state === 'Cancelado'
                  "
                  >Anulado por:
                </strong>
                <strong v-else-if="datosMov.state === 'Registrado'"
                  >Registrado por:
                </strong>
                <strong v-else-if="datosMov.state === 'Recibido'"
                  >Recibido por:
                </strong>
                <strong v-else-if="datosMov.state === 'Aprobado'"
                  >Aprobado por:
                </strong>
                <p class="">
                  {{
                    datosMov.state === "Registrado"
                      ? datosMov.userRegister.fullname
                      : datosMov.state === "Recibido" ||
                        datosMov.state === "Aprobado"
                      ? datosMov.userReceiver.fullname
                      : datosMov.internalRecords[
                          datosMov.internalRecords.length - 1
                        ].userChanged.fullname
                  }}
                </p>
              </b-col>
              <b-col
                sm="6"
                lg="2"
                class="flex"
                v-if="datosMov.state === 'Despachado'"
              >
                <strong>Transportado por: </strong>
                <p class="">{{ datosMov.userReceiver.fullname }}</p>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="bg-secondary border-b-2">
            <h4 class="text-white">Detalles de Movimiento</h4>
          </b-card-header>
          <b-card-text class="">
            <b-table
              class="position-relative"
              :hover="true"
              :items="details"
              responsive
              :fields="fields"
              show-empty
              empty-text="No existen"
              @sort-changed="sortChanged"
            >
            </b-table>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col sm="3">
                  <b-form-group
                    label-cols="4"
                    label-cols-md="4"
                    label-size="md"
                    label="Entradas"
                    label-for="input-md"
                  >
                    <b-form-select
                      v-model="showEntrie"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="entries"
                      @change="changeSizePage"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="3" class="mt-75" style="font-size: 12px">
                  <span> {{ totalElements }} Registros en total</span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalElements"
                    :per-page="showEntrie"
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @change="cambioPagina"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import InternalMovement from "@/services/InternalMovement";
import AutoPartsService from "@/services/AutoParts";

Vue.useimport;
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      autopartBrands: [],
      datosMov: null,
      details: [],
      fields: [
        { key: "autopart.uniqueCode", label: "Código Único", sortable: true },
        { key: 'autopartBrandName', label: 'Marca', sortable: true },
        { key: "autopart.originalCode", label: "Codigo Original", sortable: true},
        { key: "autopart.alterCode", label: "Codigo Alter.", sortable: true },
        { key: "autopart.description", label: "Descripción", sortable: false },
        { key: "qty", label: "Cantidad", sortable: true },
      ],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      sort: "id",
      order: "desc",
    };
  },
  mounted() {
    this.getData();
    this.getBrands();
  },
  methods: {
    async getData() {
      const resp = await InternalMovement.getMovInternal(
        this.$route.params.id,
        this.$store
      );

      if (resp && resp.data) {
        this.datosMov = resp.data.internalMovement;

        this.details = resp.data.internalDetail.map((detail) => {
          const brandId = detail.autopart.autopartBrandId;
          const brand = this.autopartBrands.find((b) => b.id === brandId);
          return {
            ...detail,
            autopartBrandName: brand ? brand.name : "Desconocida",
          };
        });

        this.totalElements = this.details.length;
      } else {
        console.error("Error: Datos no encontrados.");
      }
    },

    async getBrands() {
      const resp = await AutoPartsService.getAutoPartsBrand(
        "?limit=1000",
        this.$store
      );
      if (resp && resp.data && resp.data.rows) {
        this.autopartBrands = resp.data.rows;
      } else {
        this.autopartBrands = [];
      }
    },

    cambioPagina(e) {
      this.currentPage = e;
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy;
      this.order = data.sortDesc ? "desc" : "asc";
    },
    back() {
      this.$router.push("/inventario/entrada/bandeja");
    },
  },
};
</script>

<style></style>
